<div class="container"><div class="hourglass rotating">⌛</div></div>

<style>
  .container {
    display: flex;
  }
  @keyframes rotating {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .rotating {
    animation: rotating 2s linear infinite;
  }
</style>
